import { ReactElement } from "react";
import NavBar from "./NavBar";
import { Link } from "react-router-dom";

interface PageProps {
    content: ReactElement
    selected?: string;
}

export default function Page(props: PageProps) {
    return (
        <div id="page">
            <div id='header' className='center'>
                <Link className="title-link" to='/'>
                    <div id='title'>
                        <h3>art<br/>of</h3>
                        <h1>laney sang</h1>
                    </div>
                </Link>
                <NavBar selected={props.selected}/>
            </div>
            <div id="page-content">
                {props.content}
            </div>
            <hr />
            <p className='center'>&#169; 2026 Alaina Sang</p>
        </div>
    )
}